import { simpleUserFragment } from './fragmentsUser';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const userUpdateMutationAtom = createMutationAtomFactory(
  'admin.userUpdate',
  (params: {
    id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    timezone?: string;
    idpId?: string;
  }) => ({
    coreUserUpdate: {
      __args: {
        id: params.id,
        input: {
          firstName: params.firstName,
          lastName: params.lastName,
          email: params.email,
          phoneNumber: params.phoneNumber,
          timezone: params.timezone,
          idpId: params.idpId,
        },
      },
      ...simpleUserFragment,
    },
  }),
);
